
if ($('.js-basket-add').length > 0) {
	$('.basket').addClass('basket--active');
}


